import { Box, Heading, Text } from '@chakra-ui/react';

const EndPage = () => (
  <Box>
    <Heading size="lg">Thank you page </Heading>
    <Text my="4">Thanks for reaching out. You&apos;ll hear from us shortly.</Text>
  </Box>
);

export default EndPage;
